import axios from "axios";

const ResetPasswordFetch = async ({ token, password }) => {
	let { data, status } = await axios.post(
    `https://godrej.app-assertai.com:5000/Auth/resetpassword?token=${token}`,
    {
      password,
    }
  );
  return { status: status, data: data.message };
};
export default ResetPasswordFetch;
